import { api } from '@/components/tasks/api';

/*
 * Utenti > Task: progetto (chiave, colonne, etichette) e membri del profilo, letti una volta
 * e riusati da tutte le viste. `version` sale a ogni evento TASK_UPDATED dal socket: board,
 * backlog e scheda aperti lo osservano e si ricaricano.
 */
const state = {
	project: null,
	members: [],
	version: 0,
	lastChange: null,
};

const getters = {
	project: state => state.project,
	columns: state => (state.project ? state.project.columns : []),
	labels: state => (state.project ? state.project.labels : []),
	members: state => state.members,
	version: state => state.version,
	lastChange: state => state.lastChange,
	column: state => id => (state.project ? state.project.columns.find(c => c.id === id) : null) || null,
	member: state => id => state.members.find(m => m._id === String(id && id._id ? id._id : id)) || null,
};

const actions = {
	async load({ state, dispatch }, { force = false } = {}) {
		if (state.project && !force) return state.project;
		await Promise.all([dispatch('loadProject'), dispatch('loadMembers')]);
		return state.project;
	},
	async loadProject({ commit }) {
		commit('setProject', await api.get('project'));
	},
	async loadMembers({ commit }) {
		commit('setMembers', await api.get('members'));
	},
	async saveProject({ commit }, data) {
		const project = await api.put('project', data);
		commit('setProject', project);
		return project;
	},
	remoteChange({ commit }, data) {
		commit('bump', data || {});
	},
};

const mutations = {
	setProject: (state, project) => {
		state.project = project;
	},
	setMembers: (state, members) => {
		state.members = members || [];
	},
	bump: (state, data) => {
		state.lastChange = data;
		state.version += 1;
	},
};

export default { namespaced: true, state, getters, actions, mutations };
